module.exports = __webpack_public_path__ + "static/img/1-bg.47263b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1-bg.png
// module id = mmoV
// module chunks = 0